<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="none">
    <path
      fill="currentColor"
      d="M.333.333c.2-.2.534-.333.8-.333.334 0 .6.133.8.333L8 6.4 14.067.333c.133-.133.2-.2.4-.266.066 0 .2-.067.4-.067.133 0 .333 0 .466.067.134.066.267.133.4.266.134.134.2.267.267.4v.4c0 .134 0 .334-.067.467a1.4 1.4 0 0 1-.266.4L9.6 8l6.067 6.067c.2.2.333.533.333.8 0 .266-.133.6-.333.8s-.467.333-.8.333c-.267 0-.6-.133-.8-.333L8 9.6l-6.067 6.067c-.2.2-.466.333-.8.333-.266 0-.6-.133-.8-.333a1.23 1.23 0 0 1-.333-.8c0-.267.133-.6.333-.8L6.4 8 .333 2C.133 1.733 0 1.467 0 1.133 0 .867.133.6.333.333"
    />
  </svg>
</template>
